export default __webpack_public_path__ + "static/media/cadprod.ad6d66fe.webp";